<template>
  <div class="px-3">
    <section-separator size="lg" has-border class="mb-3">
      {{$t('generic.phones')}}
    </section-separator>
    <data-table :service="PhoneService"
                :entity="entity"
                :columns="columns"
                :go-to-add-on-click="false"
                :go-to-details-on-row-click="false"
                :disable-permission-checks="true"
                :allow-api-delete="false"
                :service-path="servicePath"
                @on-add="addRow"
                @on-row-click="onEdit"
                @on-delete="onDelete"
                operations="add,delete,refresh"
                ref="table">
      <template v-slot:primary="{row}">
        <base-switch :value="row.primary" @input="value => onPrimaryChange(row, value)"/>
      </template>
      <template v-slot:financial="{row}">
        <base-switch :value="row.financial" @input="value => onFinancialChange(row, value)"/>
      </template>
      <template v-slot:delivery="{row}">
        <base-switch :value="row.delivery" @input="value => onDeliveryChange(row, value)"/>
      </template>
      <template v-slot:created_at="{row}">
        {{$formatDate(row.created_at, FRIENDLY_DATETIME_FORMAT)}}
      </template>

      <template v-slot:extra-buttons="{row}">
        <tooltip-icon-button icon="far fa-edit"
                             :content="$t('generic.edit')"
                             @click.stop="onEdit(row)">
        </tooltip-icon-button>
      </template>
    </data-table>
    <phone-modal v-if="showAddModal"
                   :loading="loading"
                   :show.sync="showAddModal"
                   @submit="onAddSubmit"/>

    <phone-modal v-if="showEditModal"
                   :show.sync="showEditModal"
                   :data="rowToEdit"
                   :loading="loading"
                   @submit="onEditSubmit"/>

  </div>
</template>
<script>
  import PhoneService from 'src/services/PhoneService'
  import PhoneModal from 'src/views/admin/contacts/common/PhoneModal'
  import TooltipIconButton from 'src/components/Buttons/TooltipIconButton'
  import entities from 'src/config/entities'
  import { FRIENDLY_DATETIME_FORMAT } from 'src/config/dateUtils'

  export default {
    name: 'phone-list',
    components: {
      PhoneModal,
      TooltipIconButton
    },
    props: {
      primaryEntity: {
        type: String,
        default: 'user'
      },
      id: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        FRIENDLY_DATETIME_FORMAT,
        PhoneService,
        entity: entities.PHONE,
        rowToEdit: null,
        showAddModal: false,
        showEditModal: false,
        loading: false,
      }
    },
    computed: {
      entityId() {
        return this.id || this.$route.params.id
      },
      servicePath () {
        return `/${this.primaryEntity}/${this.entityId}/phones`
      },
      columns () {
        return [
          {
            prop: 'phone',
            label: this.$t('generic.phone'),
            minWidth: '200px',
            sortable: true
          },
          {
            prop: 'primary',
            label: this.$t('generic.primary'),
            minWidth: '100px',
            sortable: true
          },
          {
            prop: 'financial',
            label: this.$t('generic.financial'),
            minWidth: '100px',
            sortable: true
          },
          {
            prop: 'delivery',
            label: this.$t('generic.delivery'),
            minWidth: '100px',
            sortable: true
          },
          {
            prop: 'created_at',
            label: this.$t('generic.createdAt'),
            minWidth: '170px',
            sortable: true
          }
        ]
      }
    },
    methods: {
      addRow () {
        this.showAddModal = true
      },
      onEdit (row) {
        this.showEditModal = true
        this.rowToEdit = row
      },
      refreshData() {
        this.$refs.table.refresh()
      },
      async onPrimaryChange (row) {
        await PhoneService.setPrimary({
          entity: this.primaryEntity,
          entityId: this.entityId,
          id: row.id,
        })
        this.refreshData()
      },
      async onFinancialChange (row) {
        await PhoneService.setFinancial({
          entity: this.primaryEntity,
          entityId: this.entityId,
          id: row.id,
        })
        this.refreshData()
      },
      async onDeliveryChange (row) {
        await PhoneService.setDelivery({
          entity: this.primaryEntity,
          entityId: this.entityId,
          id: row.id,
        })
        this.refreshData()
      },
      async onDelete (row) {
        await PhoneService.deletePhone({
          entity: this.primaryEntity,
          entityId: this.entityId,
          id: row.id,
        })
        this.$notify({type: 'success', message: this.$t('phone.delete.success')})
      },
      async onAddSubmit (data) {
        try {
          this.loading = true
          await PhoneService.addPhone({
            entity: this.primaryEntity,
            entityId: this.entityId,
            data,
          })
          this.showAddModal = false
          this.$notify({type: 'success', message: this.$t('phone.add.success')})
          this.refreshData()
        } finally {
          this.loading = false
        }
      },
      async onEditSubmit (data) {
        try {
          this.loading = true

          await PhoneService.updatePhone({
            entity: this.primaryEntity,
            entityId: this.entityId,
            data,
          })
          this.showEditModal = false
          this.$notify({type: 'success', message: this.$t('phone.update.success')})
          this.refreshData()
        } finally {
          this.loading = false
        }
      }
    }
  }
</script>
<style>
</style>
